import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import { siteContent } from './data';

function MetaUpdater() {
  const location = useLocation();

  useEffect(() => {
    const pathMap = {
      '/': siteContent.meta.home,
      '/services': siteContent.meta.services,
      '/about': siteContent.meta.about,
      '/contact': siteContent.meta.contact
    };

    const meta = pathMap[location.pathname] || siteContent.meta.home;
    
    document.title = meta.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', meta.description);
    document.querySelector('meta[name="keywords"]')?.setAttribute('content', meta.keywords);
  }, [location]);

  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-black">
      <BrowserRouter>
        <MetaUpdater />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;